import { toLightboxSlides } from '@eliadmin/core/src/utils/image-alt-utils';
import NextJsImage from '@eliadmin/core/src/components/ui/nextjs-image';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import './lightbox-styles-override.css';
import { type RenderSlideProps } from 'yet-another-react-lightbox';

type LightboxComponentProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  images: any[];
  zoom?: { maxZoomPixelRatio: number; zoomInMultiplier?: number; doubleTapDelay?: number };
};

export const LightboxComponent = ({ isOpen, setIsOpen, images, zoom }: LightboxComponentProps) => {
  return (
    <Lightbox
      open={isOpen}
      close={() => setIsOpen(false)}
      slides={toLightboxSlides(images)}
      plugins={[Thumbnails, Zoom]}
      zoom={{
        maxZoomPixelRatio: 2,
        zoomInMultiplier: 2,
        doubleTapDelay: 300,
        ...zoom, // Merge custom zoom props
      }}
    />
  );
};
